import * as React from 'react';

import styles from './styles.module.scss';

function GroupEntriesLoading() {
	return (
		<>
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
			<div className={styles.GroupEntryLoading} />
		</>
	);
}

export default React.memo(GroupEntriesLoading);
